import React, { useState, useEffect, useMemo } from 'react';
import Navbar from './Navbar.js';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto'
import { useNavigate, useLocation } from 'react-router-dom';

const Statistic = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { airportPickupData } = location.state || {};

    //Chart
    const [dailyDataCounts, setDailyDataCounts] = useState({});

    useEffect(() => {
        if (!airportPickupData || airportPickupData.length === 0) return;

        const dataCounts = {};
        const today = new Date().toISOString().split('T')[0]; // Today's date in YYYY-MM-DD format

        for (let i = 0; i < 7; i++) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            const dateString = date.toISOString().split('T')[0];

            const count = airportPickupData.filter(item => item.CreateByDate.includes(dateString)).length;
            dataCounts[dateString] = count;
        }

        setDailyDataCounts(dataCounts);
    }, [airportPickupData]);

    const [topEmails, setTopEmails] = useState([]);
    const [topCounts, setTopCounts] = useState([]);

    useEffect(() => {
        // Calculate email counts
        const emailCounts = {};
        airportPickupData.forEach(item => {
            const email = item.Email;
            emailCounts[email] = (emailCounts[email] || 0) + 1;
        });

        // Convert emailCounts object to an array of objects for easier sorting
        const emailCountsArray = Object.keys(emailCounts).map(email => ({
            email,
            count: emailCounts[email]
        }));

        // Sort emailCountsArray by count in descending order
        emailCountsArray.sort((a, b) => b.count - a.count);

        // Get the top 3 email senders
        const topEmailSenders = emailCountsArray.slice(0, 3);

        // Extract the top 3 emails and their counts
        const topEmails = topEmailSenders.map(sender => sender.email);
        const topCounts = topEmailSenders.map(sender => sender.count);

        // Set state
        setTopEmails(topEmails);
        setTopCounts(topCounts);
    }, [airportPickupData]);

    ///Statistic data
    if (!airportPickupData || airportPickupData.length === 0) {
        return <div><center><h1>No data available. Please come to statistic page from: airportpickup.islandhospital.com/adminportal </h1></center></div>;
    }

    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

    // Calculate total data created today
    const todayData = airportPickupData.filter(item => {
        return item.CreateByDate.includes(today); // Check if CreateByDate includes today's date
    });
    const totalToday = todayData.length;

    // Calculate count of data with Status === 'Pending'
    const pendingData = airportPickupData.filter(item => item.Status === 'Pending');
    const totalPending = pendingData.length;

    if (localStorage.getItem("currentuser") === null) {
        navigate('/adminLogin')
        return (
            <div>
                <h1>Please login to continue</h1>
                <button className="logout-button" onClick={() => { navigate('/adminLogin'); }}>Login</button>
            </div>
        );
    }

    return (
        <div>
            <Navbar currentPage='Statistic' />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '20px',
                backgroundColor: '#f5f5f5'
            }}>
                {airportPickupData ? (
                    <div style={{
                        maxWidth: '1200px',
                        width: '100%',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <h2 style={{ color: '#096D6F', textAlign: 'center', marginBottom: '30px' }}>
                            Airport Pickup Data Statistics (Portal Data only)
                        </h2>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: '20px',
                            marginBottom: '30px'
                        }}>
                            <div style={{
                                padding: '20px',
                                backgroundColor: '#fff3cd',
                                borderRadius: '8px',
                                textAlign: 'center'
                            }}>
                                <h3>Pending Requests</h3>
                                <p style={{ fontSize: '24px', color: '#856404' }}>{totalPending}</p>
                            </div>
                            <div style={{
                                padding: '20px',
                                backgroundColor: '#d4edda',
                                borderRadius: '8px',
                                textAlign: 'center'
                            }}>
                                <h3>Today's Requests</h3>
                                <p style={{ fontSize: '24px', color: '#155724' }}>{totalToday}</p>
                            </div>
                        </div>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
                            gap: '30px'
                        }}>
                            <div style={{ height: '400px' }}>
                                <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Daily Requests</h3>
                                <Bar
                                    data={{
                                        labels: Object.keys(dailyDataCounts),
                                        datasets: [{
                                            label: 'Data Created',
                                            data: Object.values(dailyDataCounts),
                                            backgroundColor: 'rgba(54, 162, 235, 0.6)',
                                            borderColor: 'rgba(54, 162, 235, 1)',
                                            borderWidth: 1
                                        }]
                                    }}
                                    options={{
                                        maintainAspectRatio: false,
                                        scales: {
                                            y: {
                                                beginAtZero: true,
                                                ticks: { precision: 0 }
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ height: '400px' }}>
                                <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Top Email Senders</h3>
                                <Bar
                                    data={{
                                        labels: topEmails,
                                        datasets: [{
                                            label: 'Number of Emails',
                                            data: topCounts,
                                            backgroundColor: [
                                                'rgba(255, 99, 132, 0.6)',
                                                'rgba(75, 192, 80, 0.6)',
                                                'rgba(255, 206, 86, 0.6)',
                                            ],
                                            borderWidth: 1
                                        }]
                                    }}
                                    options={{
                                        maintainAspectRatio: false,
                                        scales: {
                                            y: {
                                                beginAtZero: true,
                                                ticks: { precision: 0 }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <h2>No data available.</h2>
                    </div>
                )}
            </div>
         </div>
    );
}

export default Statistic;
